const initCommentButtons = () => {
  const btnComments = document.querySelectorAll('.btn-comment');
  if (btnComments) {
    btnComments.forEach((btnComment) => {
      btnComment.addEventListener('click', (event) => {
        const inputArea = document.querySelector('.input-form-notes');
        inputArea.value = inputArea.value.concat(btnComment.innerText);
      });
    });
  };
}

export { initCommentButtons };
